import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdAdd, MdEdit, MdDelete, MdSearch } from 'react-icons/md';
import axiosInstance from '../../api/axiosInstance';

const CareerList = () => {
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const response = await axiosInstance.get('/career');
        setCareers(response.data.data || []);
      } catch (err) {
        console.error('Failed to fetch careers:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCareers();
  }, []);

  const filteredCareers = careers.filter((career) =>
    career.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this career?')) {
      try {
        await axiosInstance.delete(`/career/${id}`);
        const response = await axiosInstance.get('/career');
        setCareers(response.data.data || []);
      } catch (err) {
        alert('Failed to delete career');
        console.error('Delete error:', err);
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Careers & Jobs</h1>
        <Link
          to="/admin/careers/create"
          className="flex items-center justify-center gap-2 bg-[#008300] text-white px-4 py-2 rounded-lg hover:bg-[#006600] transition-colors text-sm sm:text-base whitespace-nowrap"
        >
          <MdAdd />\n          <span>Add Career</span>
        </Link>
      </div>

      {/* Search */}
      <div className="mb-4 sm:mb-6">
        <div className="relative">
          <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search careers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#008300] focus:border-transparent outline-none text-sm sm:text-base"
          />
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-12 text-gray-500">
          Loading careers...
        </div>
      )}

      {/* Career Table */}
      {!loading && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[280px] sm:min-w-[350px] md:min-w-[600px]">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-2 sm:px-3 md:px-4 py-3 text-left text-xs font-semibold text-gray-700">
                Title
              </th>
              <th className="px-2 sm:px-3 md:px-4 py-3 text-left text-xs font-semibold text-gray-700 hidden md:table-cell">
                Location
              </th>
              <th className="px-2 sm:px-3 md:px-4 py-3 text-left text-xs font-semibold text-gray-700">
                Type
              </th>
              <th className="px-2 sm:px-3 md:px-4 py-3 text-left text-xs font-semibold text-gray-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filteredCareers.map((career) => (
              <tr key={career.id} className="hover:bg-gray-50">
                <td className="px-2 sm:px-3 md:px-4 py-3">
                  <p className="font-medium text-gray-800 text-xs sm:text-sm">{career.title}</p>
                  <p className="text-xs text-gray-500 truncate max-w-[80px] sm:max-w-[100px] md:max-w-[150px]">
                    {career.description}
                  </p>
                </td>
                <td className="px-2 sm:px-3 md:px-4 py-3 text-gray-600 text-xs hidden md:table-cell">{career.location}</td>
                <td className="px-2 sm:px-3 md:px-4 py-3">
                  <span className="px-1.5 sm:px-2 py-0.5 sm:py-1 bg-[#008300]/10 text-[#008300] rounded-full text-xs">
                    {career.type}
                  </span>
                </td>
                <td className="px-2 sm:px-3 md:px-4 py-3">
                  <div className="flex items-center gap-1">
                    <Link
                      to={`/admin/careers/edit/${career.id}`}
                      className="p-1 text-blue-600 hover:bg-blue-50 rounded transition-colors"
                    >
                      <MdEdit className="text-sm" />
                    </Link>
                    <button
                      onClick={() => handleDelete(career.id)}
                      className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
                    >
                      <MdDelete className="text-sm" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        {filteredCareers.length === 0 && (
          <div className="text-center py-12 text-gray-500 text-sm sm:text-base">
            No careers found
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default CareerList;
